import CityPageTemplate from "../city-template/CityPageTemplate";
import { viennaVaConfig } from "./data";

export default function ViennaVaPage() {
  return <CityPageTemplate config={viennaVaConfig} />;
}